import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const PlayIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="play-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 38"
    fill="none"
    className={twMerge('h-5 w-5 fill-current stroke-current', className)}
    {...props}
  >
    <path d="M.5 34.3A3.3 3.3 0 0 0 2.3 37a3.5 3.5 0 0 0 3.5 0L30.5 22a3.2 3.2 0 0 0 0-5.8L5.8 1a3.5 3.5 0 0 0-3.5 0A3.3 3.3 0 0 0 .5 3.8v30.5Z" />
  </svg>
)
